import Rest from '../Rest'

export default class EmployeeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/employees'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
